import React from 'react';
import {
  Header,
  SpaceBetween,
  Box,
  Badge,
} from "@cloudscape-design/components";
import { parseCustomerExperience } from '../../../utils/insights/contactSummaryParser';

export default function AgenteTab({
  selectedCall,
  callDetails,
  t
}) {
  // Parsear CustomerExperience si hay datos
  const parsedData = callDetails?.ConversationAnalytics?.CustomerExperience
    ? parseCustomerExperience(callDetails.ConversationAnalytics.CustomerExperience)
    : null;

  const fortalezas = parsedData?.fortalezas || {};
  const oportunidades = parsedData?.oportunidades || {};
  
  const habilidades = fortalezas.habilidades || [];
  const buenasPracticas = fortalezas.buenasPracticas || [];
  const aspectosAMejorar = oportunidades.aspectosAMejorar || [];
  const recomendaciones = oportunidades.recomendaciones || [];

  return (
    <div style={{ width: '100%', minWidth: '350px' }}>
      <SpaceBetween size="l">
      {/* Sección A: Fortalezas del agente */}
      <div>
        <Header variant="h3" margin={{ bottom: "m" }}>
          {t("insights.agentStrengths", { defaultValue: "Fortalezas del agente" })}
        </Header>
        <Box color="text-body-secondary" variant="p" margin={{ bottom: "m" }}>
          {t("insights.agentStrengthsDescription", { defaultValue: "Aspectos positivos identificados durante la conversación" })}
        </Box>
        <SpaceBetween size="m">
          {/* Habilidades */}
          <div>
            <Box variant="awsui-key-label" margin={{ bottom: "xs" }}>
              {t("insights.skills", { defaultValue: "Habilidades" })}
            </Box>
            {habilidades.length > 0 ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {habilidades.map((skill, index) => (
                  <Badge key={index} color="grey">{skill}</Badge>
                ))}
              </div>
            ) : (
              <Box color="text-body-secondary" variant="p">
                {t("insights.noneDetected", { defaultValue: "Ninguna detectada" })}
              </Box>
            )}
          </div>

          {/* Buenas prácticas */}
          <div>
            <Box variant="awsui-key-label" margin={{ bottom: "xs" }}>
              {t("insights.goodPractices", { defaultValue: "Buenas prácticas" })}
            </Box>
            {buenasPracticas.length > 0 ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {buenasPracticas.map((practice, index) => (
                  <Badge key={index} color="grey">{practice}</Badge>
                ))}
              </div>
            ) : (
              <Box color="text-body-secondary" variant="p">
                {t("insights.noneDetected", { defaultValue: "Ninguna detectada" })}
              </Box>
            )}
          </div>
        </SpaceBetween>
      </div>

      {/* Línea divisoria */}
      <div style={{ 
        borderTop: '1px solid var(--color-border-divider-default, #d1d5db)',
        margin: '16px 0'
      }} />

      {/* Sección B: Oportunidades del agente */}
      <div>
        <Header variant="h3" margin={{ bottom: "m" }}>
          {t("insights.agentOpportunities", { defaultValue: "Oportunidades del agente" })}
        </Header>
        <Box color="text-body-secondary" variant="p" margin={{ bottom: "m" }}>
          {t("insights.agentOpportunitiesDescription", { defaultValue: "Aspectos de mejora detectados en la interacción y recomendaciones sugeridas" })}
        </Box>
        <SpaceBetween size="m">
          {/* Aspectos a mejorar */}
          <div>
            <Box variant="awsui-key-label" margin={{ bottom: "xs" }}>
              {t("insights.aspectsToImprove", { defaultValue: "Aspectos a mejorar" })}
            </Box>
            {aspectosAMejorar.length > 0 ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {aspectosAMejorar.map((aspect, index) => (
                  <Badge key={index} color="blue">{aspect}</Badge>
                ))}
              </div>
            ) : (
              <Box color="text-body-secondary" variant="p">
                {t("insights.noneDetected", { defaultValue: "Ninguna detectada" })}
              </Box>
            )}
          </div>
        </SpaceBetween>
      </div>

      {/* Sección C: Recomendaciones */}
      <div>
        <Header variant="h3" margin={{ bottom: "m" }}>
          {t("insights.recommendations", { defaultValue: "Recomendaciones" })}
        </Header>
        {recomendaciones.length > 0 ? (
          <ol style={{ paddingLeft: '20px', margin: 0 }}>
            {recomendaciones.map((recommendation, index) => (
              <li key={index} style={{ marginBottom: '8px', color: 'var(--color-text-body-secondary)' }}>
                {recommendation}
              </li>
            ))}
          </ol>
        ) : (
          <Box color="text-body-secondary" variant="p">
            {t("insights.noRecommendations", { defaultValue: "No hay recomendaciones disponibles" })}
          </Box>
        )}
      </div>
    </SpaceBetween>
    </div>
  );
}
